// Border wall configuration — V4.3 Original tiles restored + south collision nudge
// ================================================================================
// Pixel art tiles sliced from a single complete square border image.
// ORIGINAL tiles with natural shadow transitions (not darkened).
// Collision: top/left/right perfect at current values, south nudged up slightly.
// ================================================================================

// ── Tile CDN URLs (original V4.0 with natural shadows) ──────────────────────────
export const BORDER_WALL_ASSETS = {
  top:      '/cdn/wall_north_76df251a.png',
  bottom:   '/cdn/wall_south_a02adb7c.png',
  left:     '/cdn/wall_west_4b88fd8e.png',
  right:    '/cdn/wall_east_07174cf3.png',
  cornerTL: '/cdn/corner_tl_696674c2.png',
  cornerTR: '/cdn/corner_tr_7bd02e7d.png',
  cornerBL: '/cdn/corner_bl_03597844.png',
  cornerBR: '/cdn/corner_br_bb13ae9c.png',
} as const;

// ── Source image dimensions ─────────────────────────────────────────────────
// Corner slices are 540x540px. Wall strips are 968 wide x 540 deep.
const SOURCE_CORNER_PX = 540;
const SOURCE_WALL_LENGTH_PX = 968;
const SOURCE_WALL_DEPTH_PX = 540;

// ── World-unit sizing ───────────────────────────────────────────────────────
// Corner = 400wu square. Wall strip tiles to fill the gap between corners.
export const BORDER_CORNER_SIZE = 400;

// Wall strip depth matches corner, length is proportional
export const BORDER_WALL_DEPTH = BORDER_CORNER_SIZE; // 400wu
export const BORDER_WALL_TILE_LENGTH = Math.round(
  (SOURCE_WALL_LENGTH_PX / SOURCE_WALL_DEPTH_PX) * BORDER_CORNER_SIZE
); // ≈ 717wu per tile

// Aspect ratios for rendering
export const WALL_HORIZ_ASPECT = SOURCE_WALL_LENGTH_PX / SOURCE_WALL_DEPTH_PX; // ~1.79
export const WALL_VERT_ASPECT = SOURCE_WALL_DEPTH_PX / SOURCE_WALL_LENGTH_PX;  // ~0.56

// ── Per-side collision at the "black line" ──────────────────────────────────
// The "black line" = the innermost prominent structural dark line in each tile,
// which visually separates the wall face from the shadow/floor area.
// Player must stop exactly at this line on all 4 sides.
//
// From pixel brightness analysis (scanning from floor toward wall):
//   North: black line at y=309/540 = 57.2% from top → 0.572 * 400 = 229wu
//   South: black line at y=268/540 = 49.6% from top → margin = 400 - 199 = 201wu
//   West:  black line at x=271/540 = 50.2% from left → 201wu from left edge
//   East:  black line at x=268/540 = 49.6% from left → margin = 400 - 199 = 201wu
export const BORDER_COLLISION_NORTH = 229;
export const BORDER_COLLISION_SOUTH = 213;
export const BORDER_COLLISION_WEST  = 201;
export const BORDER_COLLISION_EAST  = 201;

// Legacy uniform margin (kept for any code that still references it)
export const BORDER_COLLISION_MARGIN = 201;

// How far outside the world boundary the texture extends
export const OUTSIDE_TEXTURE_EXTENT = 4096;

// ── Legacy exports for compatibility ────────────────────────────────────────
export const BORDER_WALL_THICKNESS = BORDER_COLLISION_MARGIN;
export const BORDER_IMAGE_SIZE = BORDER_CORNER_SIZE;
export const BORDER_SHADOW_DEPTH = 0; // shadows are baked into the tiles
